import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_USER_PENDING_BILL_COUNT } from "./apiRoutes";

interface UseGetUserProps {
  communityId: string;
  userId: string;
  propertyId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getUserPendingBillCount = async (communityId: string, userId: string, propertyId: string) =>
  await axiosAuth.get(`${GET_USER_PENDING_BILL_COUNT}`, {
    params: {
      communityId,
      userId,
      propertyId,
    },
  });

const useGetUserPendingBillCount = ({
  communityId,
  queryParams,
  userId,
  propertyId,
}: UseGetUserProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["user-pending-bill-count", communityId],
    queryFn: () => getUserPendingBillCount(communityId, userId, propertyId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && !!userId && !!propertyId && (queryParams?.enabled ?? true),
  });
};

export default useGetUserPendingBillCount;
